import { HOME_USER_LITE } from "../../utils/trackers/GA4Constants";

const Constants={
    PREMIUM: 'nav_premium',
    FREEMIUMLOGGED: 'nav_freemium_logged',
    FREEMIUM: 'nav_freemium_not_logged',
    PREMIUM_TO_METRICS_GA: 'premium',
    FREEMIUMLOGGED_TO_METRICS_GA: 'freemium_logueado',
    FREEMIUM_TO_METRICS_GA: 'freemium',
    AFTER_LOGIN_CB: 'afterLoginCb',
    DEVICE_WITH_BITMOVIN: ["web0s", "tizen", "hisense", "zeasn", "netrange"],
    ID_POST_ROLL_BITMOVIN_DATA: 'postroll',
    ID_PRE_ROLL_BITMOVIN_DATA: 'preroll',
    ID_POST_ROLL_BITMOVIN_SERVICE: 'post-roll',
    ID_PRE_ROLL_BITMOVIN_SERVICE: 'pre-roll',
    TYPE_URL_ADS: 'vmap',
    OUTPUT_CAMPAIGN_SERVICE: 'xml_vmap1',
    HOMEUSER_LITE: "homeuser_lite",
    PLANSELECTOR: 'plan_selector',
    BACKGROUND:'background',
    LOGO: 'logo',
}

export default Constants;



// WEBPACK FOOTER //
// ./src/AAF/Ads/Constans.js